import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
const steps = ['Go through the material.', 'Open the decision maps.', 'Try the case worksheets.', 'Use the checklists.', 'Work through the 15-Minute Case Analysis Protocol™.'];
export function Guarantee() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-135" data-mp="29eq5x1x069go">
      <div className="mx-auto max-w-3xl text-center" data-id="element-136" data-mp="2ed9ula2zdzcq">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-brand-700 bg-brand-50 text-brand-800" data-id="element-137" data-mp="2echw9ri01nir">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-138" data-mp="2oanzccfjkzp7" />
          <span className="mt-1 font-serif text-2xl font-extrabold leading-none" data-id="element-139" data-mp="2o9cvkcm3jry3">7 days</span>
        </div>
        <h2 className="mt-6 font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-140" data-mp="2sag7wp4xr5uk">My 7-day guarantee</h2>
        <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-141" data-mp="xy8b16920ew5">
          I want you to be able to look inside the system before deciding whether it’s right for you. So here’s my promise:
        </p>
        <ul className="mx-auto mt-6 max-w-md space-y-2 text-left" data-id="element-142" data-mp="3nu6pmvvnn1uf">
          {steps.map(s => <li key={s} className="flex items-start gap-3 text-[16px] font-medium text-ink" data-id="element-143" data-mp="3iuu0g4hb9ioo">
              <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-brand-600" aria-hidden="true" data-id="element-144" data-mp="3dx28jago1wkh" />
              {s}
            </li>)}
        </ul>
        <p className="mt-6 text-[17px] leading-relaxed text-muted" data-id="element-145" data-mp="fctyp72cm9ji">
          If you decide within the first 7 days that the system isn’t right for you, simply follow the refund process within
          the guarantee period. <strong className="text-ink" data-id="element-146" data-mp="hnu8oiwiisa">No complicated process. No need to justify your decision.</strong>
        </p>
        <div className="mt-10" data-id="element-147" data-mp="2q6pq35nsohfn">
          <CtaButton label="Try it risk-free" data-id="element-148" data-mp="2q7r5tnfr9s3p" />
        </div>
      </div>
    </section>;
}